//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconFileFilledFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15.5 2.09998V6.49998H19.9L15.5 2.09998Z" fill="currentColor" /><path d="M14 8V2H4V22H20V8H14ZM16 18H8V16H16V18ZM16 14H8V12H16V14Z" fill="currentColor" /></svg>;
}
export default IconFileFilledFill;